var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$fetchState.error)?_c('div',{staticClass:"nuxt-error"},[_c('Error404')],1):_c('section',{class:_vm.classForPage},[_c('BasicBodyPage',{attrs:{"page-id":_vm.pageId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }